var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "members") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_line_style_24px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    id: "group_FILL1_wght400_GRAD0_opsz24",
    d: "M1,20V17.2a2.983,2.983,0,0,1,1.6-2.65,14.867,14.867,0,0,1,3.15-1.163,13.84,13.84,0,0,1,6.5,0A14.866,14.866,0,0,1,15.4,14.55,2.983,2.983,0,0,1,17,17.2V20Zm18,0V17a4.028,4.028,0,0,0-.612-2.113A5.409,5.409,0,0,0,16.65,13.15a12.485,12.485,0,0,1,4.5,1.4,4.434,4.434,0,0,1,1.375,1.112A2.138,2.138,0,0,1,23,17v3ZM9,12a3.852,3.852,0,0,1-2.825-1.175A3.852,3.852,0,0,1,5,8,3.852,3.852,0,0,1,6.175,5.175,3.852,3.852,0,0,1,9,4a3.852,3.852,0,0,1,2.825,1.175A3.852,3.852,0,0,1,13,8a3.852,3.852,0,0,1-1.175,2.825A3.852,3.852,0,0,1,9,12ZM19,8a3.852,3.852,0,0,1-1.175,2.825A3.852,3.852,0,0,1,15,12a5.033,5.033,0,0,1-.7-.062,6.181,6.181,0,0,1-.7-.138,5.938,5.938,0,0,0,1.037-1.775,5.83,5.83,0,0,0,0-4.05A5.938,5.938,0,0,0,13.6,4.2a3.058,3.058,0,0,1,.7-.163A6.654,6.654,0,0,1,15,4a3.852,3.852,0,0,1,2.825,1.175A3.852,3.852,0,0,1,19,8Z",
    transform: "translate(1431 13)",
    fill: "#21a2ee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.c064c26a574a03f8764606ad5f5939e2.svg";
export { ForwardRef as ReactComponent };